import React, { useEffect, useMemo } from 'react';
import { Box, Inscription, SearchInput, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { OptionKey } from '@/common/types';
import {
  LOCKBOX_PAYMENT_TYPES_OPTIONS,
  LOCKBOX_STATUSES_OPTIONS,
  LOCKBOX_TYPES_OPTIONS,
} from '@/modules/employer/components/Lockbox/lockbox.types';

interface Props {
  total: number;
  searchString: string;
  setSearchString: (value: string) => void,
  types: OptionKey[],
  setTypes: (options: OptionKey[]) => void,
  statuses: OptionKey[],
  setStatuses: (options: OptionKey[]) => void,
  paymentTypes: OptionKey[],
  setPaymentTypes: (options: OptionKey[]) => void,
  isOnlyOutboundTOASelected?: boolean;
}

const LockboxListHeader: React.FC<Props> = ({
  total,
  searchString,
  setSearchString,
  types,
  setTypes,
  statuses,
  setStatuses,
  paymentTypes,
  setPaymentTypes,
  isOnlyOutboundTOASelected,
}) => {
  const lockboxStatusesWithAllOptions = useMemo(() => [ALL_OPTION, ...LOCKBOX_STATUSES_OPTIONS], []);
  const lockboxTypesWithAllOption = useMemo(() => [ALL_OPTION, ...LOCKBOX_TYPES_OPTIONS], []);
  const lockboxPaymentTypesWithAllOption = useMemo(() => [ALL_OPTION, ...LOCKBOX_PAYMENT_TYPES_OPTIONS], []);

  useEffect(() => {
    if (!isOnlyOutboundTOASelected) {
      setPaymentTypes([]);
    }
  }, [isOnlyOutboundTOASelected, setPaymentTypes]);

  return (
    <Box direction="row" justify="between" align="center">
      <Inscription weight={700} color="textBody">
        Records: {total || 0}
      </Inscription>

      <Box direction="row">
        <Box
          margin={{ left: 'spacing12' }}
          width="330px"
        >
          <SearchInput
            testId="lockbox_search"
            value={searchString}
            onChange={setSearchString}
            placeholder="Search for name, SSN, account number.."
            hasSearchingHistory
            hideTip
          />
        </Box>

        <Box
          margin={{ left: 'spacing12' }}
          width="200px"
        >
          <SelectDropdown
            testId="lockbox_type"
            id="lockbox_type"
            name="lockbox type"
            prefix="Type"
            values={types}
            onChangeValues={setTypes}
            options={lockboxTypesWithAllOption}
            allMode
            activeTitle
            ellipsisMode
          />
        </Box>

        {isOnlyOutboundTOASelected && (
          <Box
            margin={{ left: 'spacing12' }}
            width="178px"
          >
            <SelectDropdown
              testId="lockbox_payment"
              id="lockbox_payment"
              name="lockbox payment"
              prefix="Payment"
              values={paymentTypes}
              onChangeValues={setPaymentTypes}
              options={lockboxPaymentTypesWithAllOption}
              singleMode
              ellipsisMode
              activeTitle
            />
          </Box>
        )}

        <Box
          margin={{ left: 'spacing12' }}
          width="170px"
        >
          <SelectDropdown
            testId="lockbox_status"
            id="lockbox_status"
            name="lockbox status"
            prefix="Status"
            values={statuses}
            onChangeValues={setStatuses}
            options={lockboxStatusesWithAllOptions}
            allMode
            activeTitle
            ellipsisMode
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LockboxListHeader;
